import React from 'react';
import cx from 'classnames';
import UI from 'UI';
import BaseWidget from 'BaseWidget';

class WidgetShowCase extends BaseWidget {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderColorPreview(name, clazz) {
        return (
            <div key={name} className={cx('bg-' + clazz, 'color-preview')}>
                <span>{name}</span>
            </div>
        );
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.editVariable != this.state.editVariable) {
            this.setState({ editVariable: nextProps.editVariable });
        }
    };

    componentDidUpdate = prevState => {
        if (prevState.editVariable != this.state.editVariable) {
            console.log('ANIMATE ', this.state.editVariable);
        }
    };

    render() {
        let { editVariable } = this.state;
        return (
            <BaseWidget.BaseBarWrap className={cx('wdp-widget', 'wdp-show-case', `field-${editVariable}`)} title="Example of widget">
                <div data-hint="Navigation background color" className={cx('nav-box', { 'wdp-theme-customizer-edit': ['nav-color'].indexOf(editVariable) != -1 })}>
                    <UI.NavBar>
                        <li>
                            <a href="#" data-hint="Def font color" className={cx({ 'wdp-theme-customizer-edit': ['nav-text-color'].indexOf(editVariable) != -1 })}>Menu Item 1</a>
                        </li>
                        <li
                            data-hint="Active menu item"
                            className={cx('wdp-nav-active', { 'wdp-theme-customizer-edit': ['primary-color', 'nav-active-color'].indexOf(editVariable) != -1 })}
                        >
                            <a
                                href="#"
                                data-hint="Active font color"
                                className={cx({ 'wdp-theme-customizer-edit': ['primary-text-color', 'nav-active-text-color'].indexOf(editVariable) != -1 })}
                            >
                                Menu Item 2
                            </a>
                        </li>
                        <li>
                            <a href="#" data-hint="Def font color" className={cx({ 'wdp-theme-customizer-edit': ['nav-text-color'].indexOf(editVariable) != -1 })}>Menu Item 3</a>
                        </li>
                        <li>
                            <a href="#" data-hint="Def font color" className={cx({ 'wdp-theme-customizer-edit': ['nav-text-color'].indexOf(editVariable) != -1 })}>Menu Item 1</a>
                        </li>
                    </UI.NavBar>
                </div>

                <div className={cx('wdp-content', { 'wdp-theme-customizer-edit': editVariable == 'bg-color' })} data-hint="Background of widget">
                    <div>{UI.nbsp}</div>
                    <div className={cx({ 'wdp-theme-customizer-edit': editVariable == 'gray-base' })} data-hint="Fonts, strokes, dividers">
                        <p><span className="accent variable">$gray-base</span> color is negative to background. It is used to create default text colors, stokes, dividers etc.</p>
                        {['gray-base', 'gray-darker', 'gray-dark', 'gray', 'gray-light', 'gray-lighter'].map(e => {
                            return this.renderColorPreview(e, e);
                        })}
                        <p>
                            Main text color will inherin
                        </p>
                        <p className="sub-text-color">
                            <sm>Main text color will inhering</sm>
                        </p>
                    </div>
                    <div className="wdp-divider wdp-vertical-margin wdp-full-width" />
                    <div className={cx({ 'wdp-theme-customizer-edit': ['primary-color', 'primary-text-color'].indexOf(editVariable) != -1 })} data-hint="Accents">
                        <p>
                            <span className={cx('variable', { accent: ['primary-color'].indexOf(editVariable) != -1 })}>$primary-color</span> color is as background of active
                            elements or to highlight important data
                        </p>
                        <p>
                            <span className={cx('variable', { accent: ['primary-text-color'].indexOf(editVariable) != -1 })}>$primary-text-color</span> color is used for text where{' '}
                            <span className="variable">$primary-color</span> is used
                        </p>
                        {['primary-color', 'primary-text-color'].map(e => {
                            return this.renderColorPreview(e, e);
                        })}

                        <p className="bg-primary-color primary-text-color" style={{ padding: '5px', textAlign: 'center' }}>
                            Main text color will inherit
                        </p>
                    </div>
                    <div className="wdp-divider wdp-vertical-margin wdp-full-width" />

                    <div
                        className={cx(`field-${editVariable}`, {
                            'wdp-theme-customizer-edit':
                                [
                                    'home-color',
                                    'away-color',
                                    'chart-bar-away-color',
                                    'chart-bar-home-color',
                                    'chart-bar-away-color',
                                    'chart-bar-label-text-color',
                                    'chart-bar-back-color'
                                ].indexOf(editVariable) != -1
                        })}
                        data-hint="Comparing teams"
                    >
                        <p>
                            <span className={cx('variable', { accent: ['home-color'].indexOf(editVariable) != -1 })}>$home-color</span> and{' '}
                            <span className={cx('variable', { accent: ['away-color'].indexOf(editVariable) != -1 })}>$away-color</span> colors are used to when comparing two teams
                        </p>

                        <UI.BarChart className="wdp-barchart-test wdp-theme-customizer-edit" type="h2h" title="Simple Bar" values={[[10, '10'], [10, '10']]} />
                        <br />
                    </div>

                    <div className={cx(`field-${editVariable}`, 'wdp-full-width', { 'wdp-theme-customizer-edit': ['live-color', 'live-text-color'].indexOf(editVariable) != -1 })}>
                        <UI.EventCell event={data.eventLive} showClubsJerseys={true} display="compact_v2" />
                        <UI.EventCell event={data.eventComming} showClubsJerseys={true} display="compact_v2" />
                        <UI.EventCell event={data.eventFinished} showClubsJerseys={true} display="compact_v2" />
                        <UI.EventCell event={data.eventHT} showClubsJerseys={true} display="compact_v2" />
                    </div>

                </div>
            </BaseWidget.BaseBarWrap>
        );
    }
}

let data = {
    eventLive: {
        _id: '57ae735cca3c1dff73d94ab7',
        eventId: 2349244,
        startDate: '2016-12-07T15:30:00.000Z',
        statusType: 'inprogress',
        statusFull: '1st half',
        homeId: 584106,
        awayId: 474523,
        homeName: 'Racing Roma',
        awayName: 'Tuttocuoio',
        homeShortName: 'CTR',
        awayShortName: 'TUT',
        countryId: 4,
        country: 'Italien',
        tournamentName: 'Italien Serie C1 A',
        tournamentStageId: 845999,
        tournamentYear: '2016/2017',
        tournamentId: 10776,
        tournamentTemplateId: 147,
        sportId: 1,
        sport: 'football',
        teams: [584106, 474523],
        version: 31,
        score: { home: '1', away: '0' },
        detailedScore: { runningscore: { home: '1', away: '0' }, ordinarytime: { home: '1', away: '0' } },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: { round: '17', live: 'yes', gameStarted: '2016-12-07T15:30:51.000Z' },
        homeCountryId: 4,
        awayCountryId: 4
    },
    eventComming: {
        _id: '57bf969b8946a8c3793f248c',
        eventId: 2363765,
        startDate: '2016-12-07T19:45:00.000Z',
        statusType: 'notstarted',
        statusFull: 'Not started',
        homeId: 8633,
        awayId: 9789,
        homeName: 'Real Madrid',
        awayName: 'Borussia Dortmund',
        homeShortName: 'REA',
        awayShortName: 'DOR',
        countryId: 11,
        country: 'International',
        tournamentName: 'Champions League',
        tournamentStageId: 846094,
        tournamentYear: '2016/2017',
        tournamentId: 10436,
        tournamentTemplateId: 42,
        sportId: 1,
        sport: 'football',
        teams: [8633, 9789],
        version: 25,
        incidents: [],
        betOffers: [
            {
                type: '1x2',
                scope: 'ord',
                odd1: 1.85,
                oddX: 4,
                odd2: 4.2,
                live: false,
                providerId: 23
            },
            { type: '1x2', scope: 'ord', odd1: 1.87, oddX: 3.75, odd2: 3.9, live: false, providerId: 144 }
        ],
        score: { away: '0', home: '0' },
        detailedScore: { runningscore: { home: '0', away: '0' }, ordinarytime: { home: '0', away: '0' } },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: {
            round: '6',
            live: 'yes',
            liveStatsType: 'livestats',
            venueName: 'Estadio Santiago Bernabeu',
            refereeFK: '298894',
            hasLineup: true,
            hasLineupSent: true
        },
        homeCountryId: 8,
        awayCountryId: 3
    },
    eventFinished: {
        _id: '57bf96968946a8c3793f2419',
        eventId: 2363692,
        startDate: '2016-12-06T19:45:00.000Z',
        statusType: 'finished',
        statusFull: 'Finished',
        homeId: 8688,
        awayId: 10188,
        homeName: 'Dynamo Kiev',
        awayName: 'Besiktas',
        homeShortName: 'DYN',
        awayShortName: 'BES',
        countryId: 11,
        country: 'International',
        tournamentName: 'Champions League',
        tournamentStageId: 846090,
        tournamentYear: '2016/2017',
        tournamentId: 10436,
        tournamentTemplateId: 42,
        sportId: 1,
        sport: 'football',
        teams: [8688, 10188],
        version: 109,

        score: { home: '6', away: '0' },
        detailedScore: {
            finalresult: { home: '6', away: '0' },
            halftime: { home: '4', away: '0' },
            runningscore: { home: '6', away: '0' },
            ordinarytime: { home: '6', away: '0' }
        },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: {
            round: '6',
            live: 'yes',
            venueName: 'Stadion NSK Olimpiyskiy, Kyiv',
            liveStatsType: 'livestats',
            refereeFK: '155022',
            hasLineup: true,
            hasLineupSent: true,
            lineupConfirmed: 'yes',
            lineupConfirmedSent: true,
            gameStarted: '2016-12-06T19:47:35.000Z',
            firstHalfEnded: '2016-12-06T20:35:45.000Z',
            secondHalfStarted: '2016-12-06T20:52:30.000Z',
            spectators: '14036',
            secondHalfEnded: '2016-12-06T21:37:36.000Z',
            gameEnded: '2016-12-06T21:37:36.000Z',
            verified: 'yes'
        },
        homeCountryId: 53,
        awayCountryId: 13
    },
    eventHT: {
        _id: '57bf96968946a8c3793f2419',
        eventId: 2363692,
        startDate: '2016-12-06T19:45:00.000Z',
        statusType: 'finished',
        statusFull: 'Finished',
        homeId: 8688,
        awayId: 10188,
        homeName: 'Dynamo Kiev',
        awayName: 'Besiktas',
        homeShortName: 'DYN',
        awayShortName: 'BES',
        countryId: 11,
        country: 'International',
        tournamentName: 'Champions League',
        tournamentStageId: 846090,
        tournamentYear: '2016/2017',
        tournamentId: 10436,
        tournamentTemplateId: 42,
        sportId: 1,
        sport: 'football',
        teams: [8688, 10188],
        version: 109,

        score: { home: '6', away: '0' },
        detailedScore: {
            finalresult: { home: '6', away: '0' },
            halftime: { home: '4', away: '0' },
            runningscore: { home: '6', away: '0' },
            ordinarytime: { home: '6', away: '0' }
        },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: {
            round: '6',
            live: 'yes',
            venueName: 'Stadion NSK Olimpiyskiy, Kyiv',
            liveStatsType: 'livestats',
            refereeFK: '155022',
            hasLineup: true,
            hasLineupSent: true,
            lineupConfirmed: 'yes',
            lineupConfirmedSent: true,
            gameStarted: '2016-12-06T19:47:35.000Z',
            firstHalfEnded: '2016-12-06T20:35:45.000Z',
            secondHalfStarted: '2016-12-06T20:52:30.000Z',
            spectators: '14036',
            secondHalfEnded: '2016-12-06T21:37:36.000Z',
            gameEnded: '2016-12-06T21:37:36.000Z',
            verified: 'yes'
        },
        homeCountryId: 53,
        awayCountryId: 13
    }
};

export default WidgetShowCase;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/core/WidgetShowCase.js
 **/